// create with react-terminal-ui library
// type and send command to machine

import React, { useState, useEffect } from "react";
import Terminal, { TerminalInput, TerminalOutput } from "react-terminal-ui";
import useStore from "../../../zustand/useStore";

export const UR5eTerminalController = () => {
  const setRTDE = useStore((state) => state.setRTDE);
  const setButtonClickRTDE = useStore((state) => state.setButtonClickRTDE);
  const commandRespond = useStore((state) => state.commandRespond);
  const commands = useStore((state) => state.commands);

  const urMethods = [
    "movej",
    "movel",
    "movec",
    "speedj",
    "speedl",
    "stopj",
    "stopl",
    "servoj",
    "set_digital_out",
    "set_analog_out",
    "set_tool_digital_output",
    "set_tool_analog_output",
    "set_payload",
    "set_gravity",
    "set_tcp",
    "set_payload_cog",
    "force_mode",
    "end_force_mode",
    "sleep"
  ];

  const [lineData, setLineData] = useState([
    <TerminalOutput>Send RTDE to Arm</TerminalOutput>,
    <TerminalOutput>EX: 'movej([0, -1.57, 1.57, 0, 1.57, 0])'</TerminalOutput>,

    <TerminalOutput></TerminalOutput>,
    <TerminalOutput className="console">
      The following commands are provided:
    </TerminalOutput>,
    <TerminalOutput>
      'cmds' displays the custom machine commands.{" "}
    </TerminalOutput>,
    <TerminalOutput>'clear' will clear the terminal.</TerminalOutput>,
  ]);

  function onInput(input) {
    let ld = [...lineData];
    ld.push(<TerminalInput>{input}</TerminalInput>);

    const cleanInput = input.trim().toLowerCase();

    if (cleanInput === "cmds") {
      if (Object.keys(commands).length === 0) {
        ld.push(<TerminalOutput>No custom commands available.</TerminalOutput>);
      } else {
        ld.push(<TerminalOutput></TerminalOutput>);
        Object.entries(commands).forEach(([commandName, command]) => {
          ld.push(
            <TerminalOutput>
              {commandName} - {command.description}
            </TerminalOutput>
          );
          ld.push(<TerminalOutput>usage - {command.usage}</TerminalOutput>);
          ld.push(<TerminalOutput></TerminalOutput>);
        });
      }
    } else if (cleanInput === "stop") {
      ld.push(<TerminalOutput>Stopped Arm</TerminalOutput>);
    } else if (cleanInput === "start") {
      ld.push(<TerminalOutput>Started Arm</TerminalOutput>);
    } else if (cleanInput === "clear") {
      setLineData([]);
      return;
    } else if (commands[cleanInput]) {
      ld.push(<TerminalOutput>Sent: {cleanInput}</TerminalOutput>);
      setRTDE(cleanInput);
      setButtonClickRTDE();
    } else {
      const match = input.trim().match(/^([a-z_]+)\((.*)\)$/);
      if (match) {
        const method = match[1];
        if (urMethods.includes(method)) {
          ld.push(<TerminalOutput>SENT: {input.trim()}</TerminalOutput>);
          setRTDE(input.trim());
          setButtonClickRTDE();
        } else {
          ld.push(
            <TerminalOutput>Unknown RTDE method: '{method}'</TerminalOutput>
          );
        }
      } else {
        ld.push(<TerminalOutput>Unrecognized command</TerminalOutput>);
      }
    }

    setLineData(ld);
  }

  useEffect(() => {
    let ld = [...lineData];
    ld.push(<TerminalOutput>{commandRespond}</TerminalOutput>);
    setLineData(ld);
  }, [commandRespond]);

  return (
    <div className="terminal">
      <Terminal name="UR5e Terminal" onInput={onInput}>
        {lineData}
      </Terminal>
    </div>
  );
};
